import { FixedPaymentWUT } from '@wix/form-fields/viewer-wut';

export default FixedPaymentWUT;
